import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutService } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PostHogService } from '../../../../shared/services/posthog.service';
import { POSTHOG_EVENT_LOGIN } from '../../../../shared/constants/posthog-events.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
@Component({
	selector: 'app-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
	// userName: string = '';
	// password: string = '';
	blockLoader: string = 'blockLoader';
	emailRegex = /^\S+@\S+\.\S+$/;
	passwordType: string = 'password';
	loginForm!: FormGroup;

	constructor(
		private router: Router,
		private logoutService: LogoutService,
		private snackbar: MatSnackBar,
		private spinner: NgxSpinnerService,
		private fb: FormBuilder,
		private posthog: PostHogService,
		private deviceDetectorService: DeviceDetectorService
	) { }

	ngOnInit() {
		this.loginForm = this.fb.group({
			userName: ['', Validators.required],
			password: ['', Validators.required],
		});
	}

	isTournamentRoute() {
		return this.router.url.includes("/logout");
	}

	async login() {
		await this.spinner.show("blockLoader");
		try {
			const isEmailFormatted = this.isEmailFormatted(this.loginForm.value.userName);
			const loginStatus: any = await this.logoutService.login(
				this.loginForm.value.userName.toLowerCase(),
				this.loginForm.value.password,
				isEmailFormatted
			);

			if (loginStatus?.status === 'failed') {
				this.snackbar.open(loginStatus.msg, "OK");
			} else if (loginStatus?.status === 'success') {
				const userData = loginStatus.userData;
				if (userData) {
					this.posthog.identify(userData.id, {
						email: userData.email,
						name: userData.name
					});

					this.posthog.capture(POSTHOG_EVENT_LOGIN, {
						signup_method: 'Email',
						device_type: this.deviceDetectorService.device,
						platform: this.deviceDetectorService.os
					});
				}
				window.location.href = this.logoutService.getPostLoginUrl(userData);
			}
		} catch (err) {
			console.error('Login failed', err);
			this.snackbar.open('Unable to login right now. Please try again.', "OK");
		} finally {
			await this.spinner.hide("blockLoader");
		}
	}

	isEmailFormatted(email: string) {
		return this.emailRegex.test(email);
	}

	changePasswordType(type: string) {
		this.passwordType = type;
		const passwordInput: any = document.getElementById('password_input');
		passwordInput.type = type;
	}

	togglePasswordVisibility(): void {
		this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
	}
}
